const state = {
  cardNo: '',
  cardDetail: {
    cardNo: '',
    compName: '',
    taxNo: '',
    compAddr: '',
    bankName: '',
    bankAccount: '',
    forbid: ''
  },
  updateCard: {
    cardNo: '',
    compName: '',
    taxNo: '',
    compAddr: '',
    bankName: '',
    bankAccount: '',
    mobile: '',
    isCharge: ''
  }
}

const mutations = {
  SET_ECARDNO(state, obj) {
    state.cardNo = obj.cardNo
  },
  SET_CARDDETAIL(state, obj) {
    state.cardDetail.cardNo = obj.cardNo
    state.cardDetail.compName = obj.compName
    state.cardDetail.taxNo = obj.taxNo
    state.cardDetail.compAddr = obj.compAddr
    state.cardDetail.bankName = obj.bankName
    state.cardDetail.bankAccount = obj.bankAccount
    state.cardDetail.mobile = obj.mobile
    state.cardDetail.forbid = obj.forbid
  },
  UPDARE_CARDDETAIL(state, obj) {
    state.cardDetail.taxNo = obj.taxNo
    state.cardDetail.compName = obj.compName
    state.cardDetail.compAddr = obj.compAddr
    state.cardDetail.bankName = obj.bankName
  },
  SET_UPDATE_DETAIL(state, obj) {
    state.updateCard.cardNo = obj.cardNo
    state.updateCard.compName = obj.compName
    state.updateCard.taxNo = obj.taxNo
    state.updateCard.compAddr = obj.compAddr
    state.updateCard.bankName = obj.bankName
    state.updateCard.bankAccount = obj.bankAccount
    state.updateCard.mobile = obj.mobile
    state.updateCard.ischarge = obj.ischarge
  },
  RESET(state) {
    state.cardNo = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
